var map = {
	"./router_versionManage.js": "JtPy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S5Eb";


//////////////////
// WEBPACK FOOTER
// ./src/pages/versionManage router_versionManage\.js$
// module id = S5Eb
// module chunks = 65